import { render } from "./MultiFileView.vue?vue&type=template&id=084ee901&scoped=true"
import script from "./MultiFileView.vue?vue&type=script&lang=js"
export * from "./MultiFileView.vue?vue&type=script&lang=js"

import "./MultiFileView.vue?vue&type=style&index=0&id=084ee901&scoped=true&lang=scss"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084ee901"]])

export default __exports__